import { defineCommand } from '../../../concepts/commands/CommandDefinition';
import { HistoryManager } from './HistoryManager';

export const undo = defineCommand(
    'undo',
    'Undo',
    (r) => {
        const history = r.call(HistoryManager);
        history.undo();
    },
);

export const redo = defineCommand(
    'redo',
    'Redo',
    (r) => {
        const history = r.call(HistoryManager);
        history.redo();
    },
);
